// extracted by mini-css-extract-plugin
export default {"spinWrap":"EditBrokerages_spinWrap__ISST7"};